import axios from 'axios';
import endpoints from "../endpoints";

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {
    endpoint: endpoints.shop_epos_tx.endpoint, // "epos-tx",
    endpoints: endpoints.shop_epos_tx.endpoints, // "epos-txs",
    endpointCancel: endpoints.shop_epos_tx.endpointCancel, // "epos-tx-cancel"
  },
  // -----------------------------------------------------------------
  getters: {
    endpoint: state => state.endpoint,
    endpoints: state => state.endpoints,
  },
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    fetch: (context, paginationData) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoints;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: paginationData,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            if (r.success) {
              if (r.data.rows == null) r.data.rows = [];
            }
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    // count: (context, paginationData) => {
    //   const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoints;

    //   paginationData.rowsPerPage = 0;
    //   paginationData.page = 0;
    //   paginationData.sortBy = ["timestamp"];
    //   paginationData.sortDirection = ["ASC"];
    //   paginationData.dateField = "timestamp";
    //   paginationData.fields = ["id", "bank_details_id"];
    //   const year = ((new Date()).getYear() + 1900);
    //   paginationData.dateStart = year + "-01-01T00:00:00.000Z";
    //   paginationData.dateEnd = year + "-12-31T23:59:59.999Z";

    //   return new Promise((resolve, reject) => {
    //     axios({
    //         url: api,
    //         data: paginationData,
    //         method: 'POST'
    //       })
    //       .then(resp => {
    //         const r = resp.data;
    //         if (r.success) {
    //           if (r.data.rows == null) r.data.rows = [];
    //         }
    //         resolve(r);
    //       })
    //       .catch(err => {
    //         if (err.response && err.response.data) {
    //           if (typeof err.response.data === 'string') {
    //             reject(err);
    //           } else {
    //             reject(err.response.data);
    //           }
    //         } else {
    //           reject(err);
    //         }
    //       });
    //   });
    // },
    create: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    read: (context, id) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + id;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          method: 'GET'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    update: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/" + data.eid;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: 'PUT'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    bulkAction: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpoint + "/bulkAction";

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    },
    cancel: (context, data) => {
      const api = context.rootGetters['global/apiUrl'] + "/" + context.state.endpointCancel;

      return new Promise((resolve, reject) => {
        axios({
          url: api,
          data: data,
          method: 'POST'
        })
          .then(resp => {
            const r = resp.data;
            resolve(r);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              if (typeof err.response.data === 'string') {
                reject(err);
              } else {
                reject(err.response.data);
              }
            } else {
              reject(err);
            }
          });
      });
    }
  }
};
